import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Select, List, Layout, Row, Col } from 'antd'

import Policy from './Policy'

@inject((store: any) => {
    const { popupStore, policiesStore } = store
    return { popupStore, policiesStore }
})
@observer
export default class RightParamSetPolicies extends Component<any, any> {
    state: any = {
        errors: {}
    }
    closePopup = () => {
        this.props.policiesStore.resetLists()
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore, policiesStore } = this.props
        const { title, right_param_set_id } = popupStore.info
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
            </div>
        )
        return (
            <Modal
                title={title}
                visible={popupStore.popupType === 'policiesList'}
                cancelText="ביטול"
                width={600}
                bodyStyle={{ padding: '0.5rem 1.5rem' }}
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                <div
                    style={{
                        display: 'flex',
                        width: '100%',
                        flexDirection: 'column',
                        padding: '0.5rem 0rem 0.8rem'
                    }}
                >
                    <Layout style={{ background: 'white' }}>
                        <Row gutter={10}>
                            <Col xs={9}>
                                <label>
                                    <strong>סינון על פי שיוך לטבלה</strong>
                                </label>
                                <Select
                                    style={{ width: '100%' }}
                                    placeholder="כל הפוליסות"
                                    onChange={async e => {
                                        await policiesStore.setFilters('right_param_set_id', e)
                                        await policiesStore.setPagination({ page: 1 })
                                    }}
                                    value={policiesStore.filters.right_param_set_id}
                                >
                                    <Select.Option value={null} key="ALL">
                                        כל הפוליסות
                                    </Select.Option>
                                    <Select.Option value={right_param_set_id} key="CURRENT">
                                        פוליסות משוייכות
                                    </Select.Option>
                                    <Select.Option value="EMPTY" key="EMPTY">
                                        פוליסות ללא שיוך
                                    </Select.Option>
                                </Select>
                            </Col>
                            <Col xs={9}>
                                <label>
                                    <strong>סינון על פי שם</strong>
                                </label>
                                <Input.Search
                                    name="filterPolicies"
                                    placeholder="הזן שם פוליסה"
                                    value={policiesStore.filters.name}
                                    onChange={e => {
                                        policiesStore.setFilters('name', e.target.value)
                                    }}
                                />
                            </Col>
                            <Col xs={6}>
                                <label>
                                    <strong>סינון על פי מזהה</strong>
                                </label>
                                <Input.Search
                                    name="filterPolicies"
                                    placeholder="הזן מזהה"
                                    value={policiesStore.filters.id}
                                    onChange={e => {
                                        policiesStore.setFilters('id', e.target.value)
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ padding: '0.5rem 0' }}>
                            <Col>
                                <Button
                                    onClick={() => {
                                        policiesStore.resetLists()
                                        policiesStore.setPagination({ page: 1 })
                                    }}
                                    style={{ marginLeft: '0.5rem' }}
                                >
                                    אפס חיפוש
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={() => policiesStore.setPagination({ page: 1 })}
                                    style={{ margin: '0' }}
                                >
                                    חפש פוליסות
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{ fontWeight: 'bold', fontSize: '1rem', margin: '0.2rem 0' }}>
                                נמצאו {policiesStore.pagination.total} פוליסות
                            </Col>
                        </Row>
                    </Layout>
                    <List
                        className="center-table"
                        style={{ width: '100%' }}
                        rowKey="id"
                        dataSource={policiesStore.list}
                        pagination={{
                            hideOnSinglePage: true,
                            onChange: e => policiesStore.setPagination({ page: e }),
                            ...policiesStore.pagination
                        }}
                        renderItem={item => (
                            <List.Item style={{ padding: '0' }}>
                                <Policy policy={item} />
                            </List.Item>
                        )}
                    />
                </div>
            </Modal>
        )
    }
}
